import { render, staticRenderFns } from "./GatheringForm.vue?vue&type=template&id=448ea338&"
import script from "./GatheringForm.vue?vue&type=script&lang=js&"
export * from "./GatheringForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports